import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              影视索引
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              按类型快速查找你想看的影片
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.name}`}
                className="group flex flex-col items-center gap-3 p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline hover:shadow-sm"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl ${item.color} flex items-center justify-center bg-opacity-15`}>
                  <i className={`${item.icon} text-2xl text-foreground-50`}></i>
                </div>
                <span className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.name}
                </span>
                <span className="text-xs text-foreground-500">
                  {item.count.toLocaleString()} 部
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}